import { orderServices } from '../../helpers/services/order.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const ORDER_MODULE = 'order';

// define action 
export const GET_ALL_ORDERS = 'getAllOrders';
export const GET_ORDER = 'getOrder';
export const CREATE_ORDER = 'createOrder';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_ORDER_REQUEST = "getAllOrders";
const GET_ORDER_REQUEST = "getOrder";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_ORDERS]({ commit }, { filter }) {
        await orderServices
            .getAllOrders(filter)
            .then(
                (result) => {
                    commit(GET_ALL_ORDER_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_ORDER]({ commit }, { id }) {
        await orderServices
            .getOrder(id)
            .then(
                (result) => {
                    commit(GET_ORDER_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
   async [CREATE_ORDER]({ commit }, { data }) {
        commit(REQUEST)
       await orderServices
            .createOrder(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.checkOutSuccess");
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Order-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { processing: true, update: true, create: true };
    },
    [GET_ALL_ORDER_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                referenceNumber: o.reference_number,
                totalAmount: o.total_amount,
                subTotalAmount: o.subtotal_amount,
                discountAmount: o.discount_amount,
                taxAmount: o.tax_amount,
                receiptSendTo: o.receipt_send_to,
                remark: o.remark,
                status: o.status,
                isPaid: o.is_paid,
                rating: o.rating,
                customerComment: o.customer_comment,
                company: o.company,
                location: o.location,
                vehicle: o.vehicle,
                customer: o.customer,
                staff: o.staff,
                orderCancel: o.order_cancel,
                address1: o.address_1,
                address2: o.address_2,
                address3: o.address_3,
                postcode: o.postcode,
                city: o.city,
                state: o.state,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })

    },
    [GET_ORDER_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            referenceNumber: o.reference_number,
            totalAmount: o.total_amount,
            subTotalAmount: o.subtotal_amount,
            discountAmount: o.discount_amount,
            taxAmount: o.tax_amount,
            receiptSendTo: o.receipt_send_to,
            remark: o.remark,
            status: o.status,
            isPaid: o.is_paid,
            rating: o.rating,
            customerComment: o.customer_comment,
            company: o.company,
            location: o.location,
            vehicle: o.vehicle,
            customer: o.customer,
            staff: o.staff,
            orderCancel: o.order_cancel,
            address1: o.address_1,
            address2: o.address_2,
            address3: o.address_3,
            postcode: o.postcode,
            city: o.city,
            state: o.state,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }
    }
}


